import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CButton,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormText,
  CRow,
  CCol,
  CInput,
  CAlert,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { useActions } from '../hooks/useActions';
import { inviteUser } from '../actions/usersActions';
import LoaderButton from '../components/LoaderButton';

const InviteUserSchema = Yup.object().shape({
  userId: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email format').required('Required'),
  phone: Yup.number().required('Required'),
});

function InviteUserForm({ modal, setModal }) {
  // get required data from store
  const { loadingInviteUser } = useSelector((state) => state.users);

  // bind dispatch to action creators
  const inviteUserAction = useActions(inviteUser);

  // component state
  const [status, setStatus] = useState(null);

  // initialize form with formik
  const { handleChange, handleSubmit, values, errors, touched } = useFormik({
    initialValues: {
      userId: '',
      email: '',
      phone: '',
    },
    onSubmit: (user, { resetForm }) => {
      inviteUserAction(user, (status) => {
        // clear form fields for success response
        if (status.type === 'success') resetForm();
        // show status message
        setStatus(status);
      });
    },
    validationSchema: InviteUserSchema,
  });

  return (
    <CModal show={modal} onClose={() => setModal(false)}>
      <CModalHeader closeButton>
        <CModalTitle>Invite User</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="row-form">
            <CCol sm="12" md="4">
              <label className="text-swtich mx-2">User ID </label>
            </CCol>
            <CCol sm="12" md="6">
              <CInput
                name="userId"
                onChange={handleChange}
                value={values.userId}
                placeholder="Enter User Id"
              />
              {errors.userId && touched.userId && (
                <CFormText color="danger" className="help-block">
                  {errors.userId}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="row-form">
            <CCol sm="12" md="4">
              <label className="text-swtich mx-2">Email </label>
            </CCol>
            <CCol sm="12" md="6">
              <CInput
                name="email"
                onChange={handleChange}
                value={values.email}
                placeholder="Enter Email"
              />
              {errors.email && touched.email && (
                <CFormText color="danger" className="help-block">
                  {errors.email}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="row-form">
            <CCol sm="12" md="4">
              <label className="text-swtich mx-2">Phone Number: </label>
            </CCol>
            <CCol sm="12" md="6">
              <CInput
                name="phone"
                onChange={handleChange}
                value={values.phone}
                placeholder="Phone Number"
              />
              {errors.phone && touched.phone && (
                <CFormText color="danger" className="help-block">
                  {errors.phone}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="row-form">
            <CCol md="12">
              {status && (
                <CAlert
                  color={status.type === 'success' ? 'success' : 'danger'}
                >
                  {status.message}
                </CAlert>
              )}
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <LoaderButton
          title="Send Invitation"
          loading={loadingInviteUser}
          onClick={handleSubmit}
          disabled={loadingInviteUser}
        />
        <CButton color="secondary" onClick={() => setModal(false)}>
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
}

export default InviteUserForm;
